<template>
  <v-row v-style:paddingLeft="$valueByBreakpoint($finPadding.left)"
         v-style:paddingRight="$valueByBreakpoint($finPadding.right)"
         fluid
         style="background-color: unset">
    <v-col cols="12">
      <fin-auto-load-more-news-list :filter="{relatedShares: {eq: this.instrumentId}}"/>
    </v-col>
  </v-row>
</template>

<script>
import FinAutoLoadMoreNewsList from "@/components/common/news/AutoLoadMoreNewsList"

export default {
  name: 'fin-company-page-news',
  components: {FinAutoLoadMoreNewsList},
  props: {
    instrumentId: {
      type: String
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
